var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-phone-number-input',{staticClass:"phone-input",attrs:{"value":_vm.phone,"size":"lg","color":"#44a2a2","valid-color":"#757575","error":_vm.error,"no-country-selector":_vm.showCountrySelector},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }